var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 92 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#337FFF",
    d: "m56.493 48.64 1.304-8.281h-8.036v-5.383c0-2.265 1.122-4.477 4.71-4.477h3.705v-7.052a44.957 44.957 0 0 0-6.523-.557c-6.614 0-10.933 3.973-10.933 11.154v6.315H33.39v8.281h7.331v20.031h9.041v-20.03h6.732Z"
  })));
};
export default SvgFb;